import { Vector3 } from "three";
const _vector = new Vector3();
const BoneToVector = (bone, out = new Vector3()) => {
  return out.fromArray(bone.joints[1].pos).sub(_vector.fromArray(bone.joints[0].pos));
};
export {
  BoneToVector
};
//# sourceMappingURL=index50.js.map
